export const educationData = [
    {
        title: "Master of Science",
        school: "University of Central Missouri, Lee's summit, USA",
        program_of_study: "Computer Science",
        date: "2024-2025"
    },
    {
        title: "Bachelor of Technology",
        school: "Bapatla Engineering College, Bapatla, IND",
        program_of_study: "Information Technology",
        date: "2019-2023"
    },
    {
        title: "Intermediate",
        school: "Sri Chaitanya Junior College, Vijayawada, IND",
        program_of_study: "MPC",
        date: "2017-2019"
    },
]